import urlProject01_1x from '../../img/projects/project13@1x.webp';
import urlProject01_2x from '../../img/projects/project13@2x.webp';

import urlProject02_1x from '../../img/projects/project11@1x.webp';
import urlProject02_2x from '../../img/projects/project11@2x.webp';

import urlProject03_1x from '../../img/projects/project12@1x.webp';
import urlProject03_2x from '../../img/projects/project12@2x.webp';

import urlProject04_1x from '../../img/projects/project01@1x.webp';
import urlProject04_2x from '../../img/projects/project01@2x.webp';

import urlProject05_1x from '../../img/projects/project02@1x.webp';
import urlProject05_2x from '../../img/projects/project02@2x.webp';

import urlProject06_1x from '../../img/projects/project03@1x.webp';
import urlProject06_2x from '../../img/projects/project03@2x.webp';

import urlProject07_1x from '../../img/projects/project04@1x.webp';
import urlProject07_2x from '../../img/projects/project04@2x.webp';

import urlProject08_1x from '../../img/projects/project05@1x.webp';
import urlProject08_2x from '../../img/projects/project05@2x.webp';

import urlProject09_1x from '../../img/projects/project06@1x.webp';
import urlProject09_2x from '../../img/projects/project06@2x.webp';

import urlProject10_1x from '../../img/projects/project07@1x.webp';
import urlProject10_2x from '../../img/projects/project07@2x.webp';

import urlProject11_1x from '../../img/projects/project08@1x.webp';
import urlProject11_2x from '../../img/projects/project08@2x.webp';

import urlProject12_1x from '../../img/projects/project09@1x.webp';
import urlProject12_2x from '../../img/projects/project09@2x.webp';

import urlProject13_1x from '../../img/projects/project10@1x.webp';
import urlProject13_2x from '../../img/projects/project10@2x.webp';

export const projectsUrl = [
  {
    url1x: urlProject01_1x,
    url2x: urlProject01_2x,
  },
  {
    url1x: urlProject02_1x,
    url2x: urlProject02_2x,
  },
  {
    url1x: urlProject03_1x,
    url2x: urlProject03_2x,
  },
  {
    url1x: urlProject04_1x,
    url2x: urlProject04_2x,
  },
  {
    url1x: urlProject05_1x,
    url2x: urlProject05_2x,
  },
  {
    url1x: urlProject06_1x,
    url2x: urlProject06_2x,
  },
  {
    url1x: urlProject07_1x,
    url2x: urlProject07_2x,
  },
  {
    url1x: urlProject08_1x,
    url2x: urlProject08_2x,
  },
  {
    url1x: urlProject09_1x,
    url2x: urlProject09_2x,
  },
  {
    url1x: urlProject10_1x,
    url2x: urlProject10_2x,
  },
  {
    url1x: urlProject11_1x,
    url2x: urlProject11_2x,
  },
  {
    url1x: urlProject12_1x,
    url2x: urlProject12_2x,
  },
  {
    url1x: urlProject13_1x,
    url2x: urlProject13_2x,
  },
];
